<div
  matRipple
  [matRippleCentered]="true"
  [matRippleUnbounded]="true"
  style="display: grid;
  width: 7em;
"
>
<a routerLink="/">
  <img
    [src]="logoUrl"
    alt="logo imtech"
  />
</a>
</div>
